import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 5E1DF73F-AEF5-48F8-B766-419FBB05C5D0
 * name note
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note.svg
 * tags
 */
export const NoteIcon = createSvgIcon(<><path d="M14,10V4.5L19.5,10M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V9L15,3H5Z" /></>, 'NoteIcon');
export default NoteIcon